<template>
  <div>
    <form @submit.prevent="raiseNewIncident">
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label>Event</label>
            <v-select class="style-chooser" v-model="incidentCategory" :options="options.incidentCategory"
              label="category_name" :reduce="(category) => category.category_name" background-color="white"
              required></v-select>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label>Incident Source</label>
            <v-select class="style-chooser" v-model="incidentSourceId" :options="options.incidentSource"
              label="source_name" :reduce="(source) => source.id" required></v-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label>Category</label>
            <v-select class="style-chooser" v-model="subCategoryId" :options="options.subCategory"
              label="sub_category_name" :reduce="(subCategory) => subCategory.id" required
              :disabled="incidentCategory == 'Accident'"></v-select>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label>Chainage No.</label>
            <input name="chNo" placeholder="Enter Chainage No." type="text" class="form-control inp-bg"
              v-model="chainageNo" required />
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label>Vehicle Class</label>
            <v-select class="style-chooser" v-model="vehicleClassId" :options="options.vehicleClass" label="class_name"
              :reduce="(vehicleClass) => vehicleClass.id" required></v-select>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label>Side</label>
            <v-select class="style-chooser" v-model="sideId" :options="options.side" label="side_name"
              :reduce="(side) => side.side_name" required></v-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label>Description</label>
            <textarea class="form-control inp-bg" v-model="incidentDescription" rows="5" required></textarea>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label>Informed To</label>
            <v-select class="style-chooser" v-model="informedTo" :options="options.informedTo" label="first_name"
              :reduce="(user) => user.id" required></v-select>
          </div>
          <div class="mb-3">
            <label>Emergency Service</label>
            <v-select class="style-chooser" v-model="emergencyService" :options="options.emergencyServices"
              label="service_name" :reduce="(service) => service.id" required></v-select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6" v-if="incidentCategory === 'Accident' && userRole === 'rpo'">
          <div class="mb-3">
            <label>Driver Name</label>
            <input name="driverName" placeholder="Driver Name" type="text" class="form-control inp-bg"
              v-model="driverName" required />
          </div>
        </div>
      </div>

      <!-- RPO -->
      <!-- <div class="row" v-if="incidentCategory === 1 && userRole === 'rpo'">
        <div class="col-12 col-xl-6">
          <div class="mb-3" v-if="userRole === 'rpo'">
            <label>Vehicle Number</label>
            <input
              name="vehicleNumber"
              placeholder="Vehicle Plate Number"
              type="text"
              class="form-control inp-bg"
              v-model="vehicleNumber"
              maxlength="10"
              style="text-transform: uppercase"
              required
            />
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <div class="mb-3">
            <label>No. of Injured People</label>
            <input
              placeholder="No. of Injured People"
              type="number"
              class="form-control inp-bg"
              v-model="injuredCount"
              required
            />
          </div>
        </div>
      </div> -->

      <!-- Image Upload -->
      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label>Incident Images</label>
            <file-pond ref="pond" class="inp-bg" label-idle="Attach Incident Images" :allow-multiple="true"
              accepted-file-types="image/jpeg, image/png" max-files="6" :files="myFiles" :credits="credits"
              imagePreviewMaxHeight="70" />
          </div>
        </div>
      </div>

      <!-- BUTTON -->
      <div class="row">
        <div class="col-12">
          <div class="mt-2 text-center">
            <button class="btn btn-primary me-1 w-25" v-if="userRole === 'rpo'">
              Save
            </button>
            <button class="btn btn-success me-1 w-25" v-if="userRole === 'rpo'">
              Resolve
            </button>
            <button type="submit" class="btn btn-primary me-1 w-50" v-if="userRole !== 'rpo'">
              Raise Incident <i class="bx bx-rocket ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import incidentMixin from "@/mixins/incident";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

import appConfig from "@/app.config";
import Swal from "sweetalert2";

export default {
  mixins: [incidentMixin],

  page: {
    title: "Raise New Incident",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    FilePond,
  },
  data () {
    return {
      incidentCategory: null,
      subCategoryId: null,
      incidentSourceId: null,
      incidentDescription: null,
      chainageNo: null,
      sideId: null,
      incidentDate: null,
      incidentTime: null,
      informedTo: null,
      credits: "",
      challanStatusId: null,
      vehicleClassId: null,
      emergencyService: null,

      options: {
        incidentCategory: [],
        subCategory: [],
        incidentSource: [],
        side: [],
        informedTo: [],
        emergencyServices: [],
        vehicleClass: []
      },

      image: "",
      file: "",
      myFiles: [],
    };
  },

  computed: {
    masters () {
      return this.$store.getters['incident/masters']
    },
    userRole () {
      return this.$store.getters["auth/user"].user.role
    }
  },

  watch: {
    incidentCategory: function () {
      if (this.incidentCategory == 'Accident') this.subCategoryId = null;
    },
  },

  methods: {
    async setMasterDataOptions () {
      try {
        // const incidents = await this.GetIncidentMasters();
        this.options.incidentCategory = this.masters.incidentCategoryMaster;
        this.options.subCategory = this.masters.incidentSubCategoryMaster;
        this.options.incidentSource = this.masters.incidentSourceMaster;
        this.options.side = this.masters.incidentSideMaster;
        // this.options.informedTo = this.masters.rpoData;
        // this.options.emergencyServices = this.masters.getEmergencyServices;
        this.options.vehicleClass = this.masters.vehicleClass
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        Swal.fire(
          "Network Error",
          "Failed to fetch data from the server. Please check your internet connection.",
          "error"
        );
      }
    },

    async raiseNewIncident () {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        const incidentDetails = {
          category: this.incidentCategory,
          subCategoryId: this.subCategoryId,
          sourceId: this.incidentSourceId,
          description: this.incidentDescription,
          chainageNo: this.chainageNo,
          side: this.sideId,
          rpoId: this.informedTo,
          vehicleClassId: this.vehicleClassId,
          reportedBy: this.$store.getters["auth/user"].user.id
        };

        const res = await this.SaveIncident(incidentDetails);

        await this.saveIncidentImages(res.id);

        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire(
          "Incident Raised",
          `Incident with ID: ${res.id} has been raised and notifications have been sent to respective RPO team.`,
          "success"
        ).then(() => {
          this.clearData();
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Error Occurred", e.response.data.message, "error");
        this.clearData();
      }
    },

    async saveIncidentImages (incidentId) {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        if (this.$refs.pond) {
          const files = this.$refs.pond.getFiles();
          for (let file of files) {
            let formData = new FormData();
            formData.append("photo", file.file);
            formData.append("id", incidentId);
            await this.SaveIncidentImages(formData);
          }
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Error Occurred", e.response.data.message, "error");
        this.clearData();
      }
    },
    clearData () {
      this.incidentCategory = null;
      this.subCategoryId = null;
      this.incidentSourceId = null;
      this.incidentDescription = null;
      this.chainageNo = null;
      this.sideId = null;
      this.vehicleNumber = null;
      this.incidentDate = null;
      this.incidentTime = null;
      this.informedTo = null;

      if (this.$refs.pond) {
        this.$refs.pond.removeFiles();
      }

      this.$emit("closeModal");
    },

    formatDate (d) {
      const date = new Date(d);
      let day = date.getDate();
      let month = date.getMonth() + 1;
      if (month < 10) month = "0" + month;
      let year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
  },
  async mounted () {
    this.$store.dispatch("layout/changeLoaderValue", true);
    await this.setMasterDataOptions();
    this.options.informedTo = await this.GetRPOUsers()
    this.options.emergencyServices = await this.GetEmergencyServices()
    this.$store.dispatch("layout/changeLoaderValue", false);
  },
};
</script>